window.addEventListener(m6Gdpr.OPEN_GDPR, function() {
    if(document.getElementsByClassName('m6Cookies_bar').length === 0)
        window.cookieBar = new m6CookiesBar();
});
document.write('<script type="text/javascript">m6Gdpr.init();</script>');
